import { SxProps, Theme } from '@mui/material';

export const commonTableSx: SxProps<Theme> = {
  mt: 2,
  mb: 5,
  borderCollapse: 'separate',
  tableLayout: 'fixed',
  width: '100%',
  th: {
    height: 20,
    backgroundColor: 'primary.tableHeadBg',
    whiteSpace: 'nowrap',
    fontWeight: 700,
    fontSize: 16,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  td: {
    fontSize: 20,
    height: 36,
    maxHeight: 36,
    maxWidth: 1,
    minWidth: 0,
    overflow: 'hidden',
    verticalAlign: 'middle',
  },
  'th:first-child': {
    borderTopLeftRadius: 3,
  },
  'th:last-child': {
    borderTopRightRadius: 3,
  },
  tr: {
    borderLeftWidth: '1.5px',
    borderRightWidth: '0.5px',
    borderStyle: 'solid',
    borderColor: 'primary.tableBorder',
  },
  'td,th': {
    py: 0.5,
    px: 0.8,
    borderWidth: '0.5px',
    borderStyle: 'solid',
    borderColor: 'primary.tableBorder',
  },
  '.MuiCheckbox-root': {
    padding: 0,
    width: 20,
    height: 20,
    '&:not(.Mui-checked)': {
      path: {
        fill: 'primary.tableBorder',
      },
    },
  },
};
